import { useIntl } from "react-intl";

import { Adg4Button } from "@/components/adg4/button/src";

import { useAccountCreationContext } from "../../hooks";

export const Submit = ({ buttonText }: { buttonText?: string }) => {
    const intl = useIntl();

    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    if (buttonText === undefined) {
        buttonText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.submit",
            defaultMessage: "Sign up"
        });
    }

    return (
        <Adg4Button
            type="submit"
            isDisabled={isSubmitting || (hasSubmitted && !formError)}
            isFullWidth={true}
            isLoading={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
        >
            {buttonText}
        </Adg4Button>
    );
};
